import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/* eslint-disable no-useless-catch */
import { Endpoints, DailyBonusResponseKeys, SpinnerItemKeys } from './Constants';
import transformObjectResponseKeys from '../utils/transformObjectResponseKeys';
import transformObjectArrayResponse from '../utils/transformObjectArrayResponse';
import RequestHelper from './RequestHelper';
import { EVENT_TYPES } from '../lib/analytics/constants';
import Logger from '../lib/analytics/logger';
import store from '../state/store';
import ERROR_CODE from '../utils/errorCodes';
export default {
  /**
   * Helper method that returns a daily bonus if available, or false otherwise.
   * @returns {Promise<import("./Constants").DailyBonusResponseKeys|boolean>}
   */
  getDailyBonus: function () {
    var _getDailyBonus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var callResponse, i, _i, bonus;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              console.log('get daily bonus:');
              /** @type {import("./Constants").DailyBonusResponseKeys|boolean} */

              _context.next = 4;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_DAILY_BONUS
              }, true);

            case 4:
              callResponse = _context.sent;

              if (!(callResponse.success === false)) {
                _context.next = 7;
                break;
              }

              throw Error("[Check-Daily-Bonus-response] ".concat(callResponse.error));

            case 7:
              if (!(callResponse === false || Object.keys(callResponse).length === 0 && callResponse.constructor === Object)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", false);

            case 9:
              callResponse = transformObjectResponseKeys(callResponse, DailyBonusResponseKeys);
              callResponse.SPINNER_ITEMS = transformObjectArrayResponse(callResponse.SPINNER_ITEMS);

              for (i = 0; i < callResponse.SPINNER_ITEMS.length; i++) {
                callResponse.SPINNER_ITEMS[i] = transformObjectResponseKeys(callResponse.SPINNER_ITEMS[i], SpinnerItemKeys);
                callResponse.SPINNER_ITEMS[i].AMOUNT = parseInt(callResponse.SPINNER_ITEMS[i].AMOUNT);
              }

              callResponse.RESPIN_COST = parseInt(callResponse.RESPIN_COST);
              callResponse.LOGIN_STREAK_COINS_LIST = transformObjectArrayResponse(callResponse.LOGIN_STREAK_COINS_LIST);
              callResponse.LOGIN_STREAK_LOYALTY_LIST = transformObjectArrayResponse(callResponse.LOGIN_STREAK_LOYALTY_LIST);
              callResponse.LOGIN_STREAK_BONUS_LIST = [];

              for (_i = 0; _i < callResponse.LOGIN_STREAK_COINS_LIST.length; _i++) {
                /** @type {import("./Constants").MergedLoginStreak} */
                bonus = {};
                bonus.coins = parseInt(callResponse.LOGIN_STREAK_COINS_LIST[_i].amount);
                bonus.loyalty = parseInt(callResponse.LOGIN_STREAK_LOYALTY_LIST[_i].amount);
                callResponse.LOGIN_STREAK_BONUS_LIST.push(bonus);
              }

              callResponse.MEMBER_TIERS = transformObjectArrayResponse(callResponse.MEMBER_TIERS);
              return _context.abrupt("return", callResponse);

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)),
                code: ERROR_CODE.GET_DAILY_BONUS_FAIL
              });
              throw _context.t0;

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 21]]);
    }));

    function getDailyBonus() {
      return _getDailyBonus.apply(this, arguments);
    }

    return getDailyBonus;
  }(),
  claimDailyBonus: function () {
    var _claimDailyBonus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var callResponse, eventPayload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.CLAIM_DAILY_BONUS
              }, true);

            case 3:
              callResponse = _context2.sent;

              if (!(callResponse.success === false)) {
                _context2.next = 8;
                break;
              }

              eventPayload = {
                description: "Failed to claim daily spin, ".concat(callResponse.error),
                code: 31
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              throw Error("[Claim-Daily-Bonus-response] ".concat(callResponse.error));

            case 8:
              return _context2.abrupt("return", callResponse);

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context2.t0, Object.getOwnPropertyNames(_context2.t0)),
                code: ERROR_CODE.CLAIM_DAILY_BONUS_FAIL
              });
              throw _context2.t0;

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 11]]);
    }));

    function claimDailyBonus() {
      return _claimDailyBonus.apply(this, arguments);
    }

    return claimDailyBonus;
  }(),
  claimTimedBonus: function () {
    var _claimTimedBonus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var response, _store$getState, coin, coinAmount, eventPayload;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.CLAIM_TIMED_BONUS,
                logJSON: true
              }, true);

            case 3:
              response = _context3.sent;

              if (!response) {
                _context3.next = 7;
                break;
              }

              if (response.success) {
                _store$getState = store.getState(), coin = _store$getState.coin;
                coinAmount = parseInt(response.rewardAmount);
                eventPayload = {
                  balance_before: (parseInt(coin.value) - coinAmount).toString(),
                  coins: coinAmount.toString()
                };
                Logger.sendEvent(EVENT_TYPES.TIMED_BONUS_CLAIMED, eventPayload);
              }

              return _context3.abrupt("return", response);

            case 7:
              _context3.next = 13;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context3.t0, Object.getOwnPropertyNames(_context3.t0)),
                code: ERROR_CODE.CLAIM_TIMED_BONUS_FAIL
              });
              throw _context3.t0;

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    }));

    function claimTimedBonus() {
      return _claimTimedBonus.apply(this, arguments);
    }

    return claimTimedBonus;
  }(),
  submitBonusableLink: function () {
    var _submitBonusableLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
      var response, state, _coinAmount, _loyaltyAmount, eventPayload, _eventPayload;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.SUBMIT_BONUSABLE_LINK,
                body: {
                  blink_id: payload.id,
                  blink_hash: payload.hash
                }
              }, true);

            case 3:
              response = _context4.sent;

              if (!response) {
                _context4.next = 7;
                break;
              }

              if (response.success) {
                state = store.getState();
                _coinAmount = response.redeem.currency === 'coins' ? response.redeem.amount : '';
                _loyaltyAmount = response.redeem.currency === 'loyalty' ? response.redeem.amount : '';
                eventPayload = {
                  balance_before: (parseInt(state.coin.value) - (_coinAmount != '' ? parseInt(_coinAmount) : 0)).toString(),
                  loyalty_points_before: (parseInt(state.loyalty.value) - (_loyaltyAmount != '' ? parseInt(_loyaltyAmount) : 0)).toString(),
                  loyalty_points: _loyaltyAmount,
                  coins: _coinAmount,
                  id: payload.id
                };
                Logger.sendEvent(EVENT_TYPES.BONUS_LINK_CLAIMED, eventPayload);
              } else {
                _eventPayload = {
                  description: "The bonus link ".concat(payload.id, " could not be claimed"),
                  code: 15
                };
                Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, _eventPayload);
              }

              return _context4.abrupt("return", response);

            case 7:
              _context4.next = 13;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context4.t0, Object.getOwnPropertyNames(_context4.t0)),
                code: ERROR_CODE.SUBMIT_BONUSABLE_LINK_FAIL
              });
              throw _context4.t0;

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));

    function submitBonusableLink(_x) {
      return _submitBonusableLink.apply(this, arguments);
    }

    return submitBonusableLink;
  }(),
  collectWelcomeBonus: function () {
    var _collectWelcomeBonus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var response;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.COLLECT_WELCOME_BONUS,
                body: {}
              }, true);

            case 3:
              response = _context5.sent;
              return _context5.abrupt("return", response);

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context5.t0, Object.getOwnPropertyNames(_context5.t0)),
                code: ERROR_CODE.COLLECT_WELCOME_BONUS_FAIL
              });
              throw _context5.t0;

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 7]]);
    }));

    function collectWelcomeBonus() {
      return _collectWelcomeBonus.apply(this, arguments);
    }

    return collectWelcomeBonus;
  }()
};